import * as React from "react";
import { createBrowserRouter } from "react-router-dom";
import Builder from "./Components/Builder";
import Home from "./Components/Home";
import Country from "./Components/Pages/Country";
import MainLayout from "./Components/Layouts/MainLayout";
import CustomLayout from "./Components/Layouts/CustomLayout";
// import WorldMap from "./Components/WorldMap";
import AboutUs from "./Components/Pages/AboutUs";
import OurStory from "./Components/Pages/OurStory";
import Vision from "./Components/Pages/Vision";
import WeInNumbers from "./Components/Pages/WeInNumbers";
import OurOffice from "./Components/Pages/OurOffice";
import Volunteer from "./Components/Pages/Volunteer";
import MostQuestioned from "./Components/Pages/MostQuestioned";
import CallUs from "./Components/Pages/CallUs";
import Partner from "./Components/Pages/Partner";
import Privacy from "./Components/Pages/Privacy";
import Gift from "./Components/Pages/Gift";
import ZacCalc from "./Components/Pages/ZacCalc";
import Blog from "./Components/Pages/Blog";
import BlogPost from "./Components/Pages/BlogPost";
import SuccessStory from "./Components/Pages/SuccessStory";
import SuccessStoryPost from "./Components/Pages/SuccessStoryPost";
import RencetNews from "./Components/Pages/RencetNews";
import NewsPost from "./Components/Pages/NewsPost";
import SocialMedia from "./Components/Pages/SocialMedia";
import MediaReleases from "./Components/Pages/MediaReleases";
import Events from "./Components/Pages/Events";
import WhatDidTheySay from "./Components/Pages/WhatDidTheySay";
import { Wrapper } from "./Providers/Wrapper";

const Router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Wrapper>
        <Home />
      </Wrapper>
    ),
    handle: {
      crumb: () => "Home",
    },
  },
  {
    path: "/builder/:pageId",
    element: <Builder />,
    handle: {
      crumb: () => "builder",
    },
  },
  // {
  //   path: "/map",
  //   element: <WorldMap />,
  //   handle: {
  //     crumb: () => "Map",
  //   },
  // },
  {
    element: (
      <Wrapper>
        <MainLayout />
      </Wrapper>
    ),
    children: [
      {
        path: "/Country",
        element: <Country />,
        handle: {
          crumb: () => "Country",
        },
      },
      {
        path: "/about-us",
        element: <AboutUs />,
        handle: {
          crumb: () => "About us",
        },
      },
      {
        path: "/our-story",
        element: <OurStory />,
        handle: {
          crumb: () => "Our Story",
        },
      },
      {
        path: "/vision",
        element: <Vision />,
        handle: {
          crumb: () => "Vision",
        },
      },
      {
        path: "/we-in-numbers",
        element: <WeInNumbers />,
        handle: {
          crumb: () => "We in Numbers",
        },
      },
      {
        path: "/our-office",
        element: <OurOffice />,
        handle: {
          crumb: () => "Our Office",
        },
      },
      {
        path: "/be-Volunteer",
        element: <Volunteer />,
        handle: {
          crumb: () => "Be Volunteer",
        },
      },
      {
        path: "/most-questioned",
        element: <MostQuestioned />,
        handle: {
          crumb: () => "الاسئلة الشائعة",
        },
      },
      {
        path: "/be-partner",
        element: <Partner />,
        handle: {
          crumb: () => "Be Partner",
        },
      },
      {
        path: "/privacy",
        element: <Privacy />,
        handle: {
          crumb: () => "Privacy",
        },
      },
      {
        path: "/zaka-calculator",
        element: <ZacCalc />,
        handle: {
          crumb: () => "Zakaa Calculator",
        },
      },
      {
        path: "/blog",
        element: <Blog />,
        handle: {
          crumb: () => "المدونة",
        },
        children: [
          {
            path: "/blog/:blogId",
            loader: async ({ request, params }) => {
              console.log(params);
              return fetch(
                `https://project.alkhair.weblayer.info/api/projects/${params.blogId}`,
                { signal: request.signal }
              );
            },
            element: <BlogPost />,
            handle: {
              crumb: (blogId) => `${blogId}`,
            },
          },
        ],
      },
      {
        path: "/success-stories",
        element: <SuccessStory />,
        handle: {
          crumb: () => "قصص النجاح",
        },
        children: [
          {
            path: "/success-stories/:storyId",
            loader: async ({ request, params }) => {
              return fetch(
                `https://project.alkhair.weblayer.info/api/projects/${params.storyId}`,
                { signal: request.signal }
              );
            },
            element: <SuccessStoryPost />,
            handle: {
              crumb: (storyId) => `${storyId}`,
            },
          },
        ],
      },
      {
        path: "/rencet-news",
        element: <RencetNews />,
        handle: {
          crumb: () => "أخر الأخبار",
        },
        children: [
          {
            path: "/rencet-news/:newsId",
            loader: async ({ request, params }) => {
              return fetch(
                `https://project.alkhair.weblayer.info/api/projects/${params.newsId}`,
                { signal: request.signal }
              );
            },
            element: <NewsPost />,
            handle: {
              crumb: (newsId) => `${newsId}`,
            },
          },
        ],
      },
      {
        path: "/social-media",
        element: <SocialMedia />,
        handle: {
          crumb: () => "مواقع التواصل",
        },
      },
      {
        path: "/media-releases",
        element: <MediaReleases />,
        handle: {
          crumb: () => "إصدارات إعلامية",
        },
      },
      {
        path: "/events",
        element: <Events />,
        handle: {
          crumb: () => "أحداث ومناسبات",
        },
      },
      {
        path: "/spoken",
        element: <WhatDidTheySay />,
        handle: {
          crumb: () => "شهادات قالوا عنا",
        },
      },
    ],
  },
  {
    element: (
      <Wrapper>
        <CustomLayout />
      </Wrapper>
    ),
    children: [
      {
        path: "/call-us",
        element: <CallUs />,
        handle: {
          crumb: () => "Call Us",
        },
      },
      {
        path: "/gift",
        element: <Gift />,
        handle: {
          crumb: () => "Gift",
        },
      },
    ],
  },
]);

export default Router;
